import { render } from "./EditPromotionModal.vue?vue&type=template&id=5b437a01&scoped=true"
import script from "./EditPromotionModal.vue?vue&type=script&lang=js"
export * from "./EditPromotionModal.vue?vue&type=script&lang=js"

import "./EditPromotionModal.vue?vue&type=style&index=0&id=5b437a01&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b437a01"]])

export default __exports__